import { render } from "./InstitutionRenewal.vue?vue&type=template&id=25c7cb8c"
import script from "./InstitutionRenewal.vue?vue&type=script&lang=js"
export * from "./InstitutionRenewal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__